import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUtensils } from 'react-icons/fa';
import '../styles/logo.css';

const ClickableLogo: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <button
      type="button"
      aria-label="Eatsy home"
      onClick={handleClick}
      className="logo-container inline-flex items-center cursor-pointer select-none"
    >
      <FaUtensils className="logo-icon" />
      <span className="logo-text">Eatsy</span>
    </button>
  );
};

export default ClickableLogo;